import { Component, inject, OnInit, OnDestroy, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Subject, takeUntil, filter } from 'rxjs';
import { SiteStore } from '../../../store/site.store';
import { GradientBackgroundComponent } from '../../gradient-background/gradient-background.component';

@Component({
  selector: 'app-page-layout',
  standalone: true,
  imports: [CommonModule, GradientBackgroundComponent],
  templateUrl: './page-layout.component.html',
  styleUrls: ['./page-layout.component.scss']
})
export class PageLayoutComponent implements OnInit, OnDestroy {
  siteStore = inject(SiteStore);
  router = inject(Router);
  activatedRoute = inject(ActivatedRoute);
  containerClass = input();
	customPt = input();

  private destroy$ = new Subject<void>();

  // Route metadata properties
  pageLayoutClass = '';

  ngOnInit() {
    this.extractRouteMetadata();

    // Listen to navigation events to update metadata
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.extractRouteMetadata();
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getClasses() {
    const classes: { [key: string]: boolean } = {
      'app-gradient': this.siteStore.$bp().ltmd && this.siteStore.$sw() < 640
    };

    if (this.pageLayoutClass) {
      classes[this.pageLayoutClass] = true;
    }

    return classes;
  }

  getContainerClasses() {
    const baseClasses = this.containerClass() || '';
    const isProfileRoute = this.router.url === '/settings/profile';
    const isQrRoute = this.router.url === '/qr/share';
    const isAccountsRoute = this.router.url === '/settings/accounts';

    if (isProfileRoute || isQrRoute) {
      return baseClasses ? `${baseClasses} no-overflow` : 'no-overflow';
    }

    if (isAccountsRoute) {
      return baseClasses
        ? `${baseClasses} no-padding-right !pb-0 !pt-0`
        : 'no-padding-right !pb-0 !pt-0';
    }

    return baseClasses;
  }

  private extractRouteMetadata() {
    let route = this.activatedRoute;

    // Navigate to the deepest child route
    while (route.firstChild) {
      route = route.firstChild;
    }

    // Extract data from route snapshot
    const routeData = route.snapshot.data;

    // Set component properties based on route data
    this.pageLayoutClass = routeData['pageLayoutClass'] || '';
  }
}
